import React from 'react';
import PropTypes from 'prop-types';

import './module.css';

const List = ({
  listItems
}) => {
  return (
    <table styleName="striped list">
      <tbody>
        {
          listItems ?
          listItems.map((item, index) =>
            <tr key={index}>
              <td>{ item }</td>
            </tr>
          ) :
          []
        }
      </tbody>
    </table>
  );
};

List.propTypes = {
  listItems: PropTypes.array.isRequired
};

export default List;
